import { Map } from 'immutable';
import { actionTypes } from '../../../actions/Administration/SettingsPage/kitPdfDetailedLabelSettingsViewActions';

let defaultState = {
  loading: false,
  headerFormData: null,
  rowFormData: null,
};

export default function(state = Map(defaultState), action) {

  switch (action.type) {

    case actionTypes.ADMINISTRATION_SETTINGS_KIT_PDF_DETAILED_LABEL_FETCH_DATA_IN_PROGRESS:
      return state.set('loading', true);

    case actionTypes.ADMINISTRATION_SETTINGS_KIT_PDF_DETAILED_LABEL_FETCH_DATA_FINISHED:
      state = state.set('headerFormData', action?.payload?.headerFormData);
      state = state.set('rowFormData', action?.payload?.rowFormData);
      state = state.set('loading', false);
      return state;

    case actionTypes.ADMINISTRATION_SETTINGS_KIT_PDF_DETAILED_LABEL_SUBMIT_IN_PROGRESS:
      return state.set('loading', true);

    case actionTypes.ADMINISTRATION_SETTINGS_KIT_PDF_DETAILED_LABEL_SUBMIT_FINISHED:
      return state.set('loading', false);

    case actionTypes.ADMINISTRATION_SETTINGS_KIT_PDF_DETAILED_LABEL_SUBMIT_FAILED:
      return state.set('loading', false);

    case actionTypes.ADMINISTRATION_SETTINGS_KIT_PDF_DETAILED_LABEL_RESET_DATA:
      return Map(defaultState);

    default:
      return state;
  }
}
